export default __webpack_public_path__ + "static/media/kardia_operations_logo.2b140193.svg";